import { render, staticRenderFns } from "./DGGestioneLF.vue?vue&type=template&id=2126f138&scoped=true&"
import script from "./DGGestioneLF.vue?vue&type=script&lang=js&"
export * from "./DGGestioneLF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126f138",
  null
  
)

export default component.exports